import React, { useEffect, useState } from "react";
import { FaTerminal, FaGit, FaCode, FaCodeBranch, FaCalendar, FaServer, FaDatabase, FaCloud } from "react-icons/fa";
import WOW from "wowjs";
import "./Experience.css";

export default function Experience() {
  const [currentDirectory] = useState("~/experience");

  useEffect(() => {
    new WOW.WOW().init();
  }, []);

  return (
    <section id="experience" className="experience-section wow fadeInUp">
      <div className="terminal-window">
        <div className="terminal-bar">
          <div className="terminal-buttons">
            <span></span>
            <span></span>
            <span></span>
          </div>
          <div className="terminal-title">
            <FaTerminal /> git-log.sh — {currentDirectory}
          </div>
        </div>

        <div className="terminal-content">
          <div className="command-line">
            <span className="prompt">$</span>
            <span className="directory">{currentDirectory}</span>
            <span className="command">git log --pretty=format:"%h %s" --graph</span>
          </div>

          <div className="git-log">
            <div className="commit wow fadeInUp">
              <div className="commit-hash">
                <FaGit /> f8e92a3
              </div>
              <div className="commit-content">
                <div className="commit-title">
                  <FaCode /> Full Stack Developer Intern @ StudyNest Global
                </div>
                <div className="commit-date">
                  <FaCalendar /> April 2025 - June 2025
                </div>
                <div className="commit-message">
                  <FaCodeBranch /> feat(web-app): Implemented full-stack features and AI integration
                  <ul>
                    <li>stack: React.js, Node.js, OpenAI APIs</li>
                    <li>perf: Optimized responsive design for cross-platform compatibility</li>
                    <li>ci/cd: Implemented Git-based workflows and deployment pipelines</li>
                    <li>test: Conducted comprehensive testing for production stability</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="commit wow fadeInUp">
              <div className="commit-hash">
                <FaGit /> 7d4e1b2
              </div>
              <div className="commit-content">
                <div className="commit-title">
                  <FaServer /> Full Stack Developer Intern @ BeachCherry Software
                </div>
                <div className="commit-date">
                  <FaCalendar /> January 2025 - March 2025
                </div>
                <div className="commit-message">
                  <FaCodeBranch /> feat(mern): Developed scalable web application
                  <ul>
                    <li>stack: MERN (MongoDB, Express, React, Node.js)</li>
                    <li>security: Implemented JWT authentication</li>
                    <li>db: Optimized MongoDB schemas and queries</li>
                    <li>ui: Led front-end design and implementation</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="commit wow fadeInUp">
              <div className="commit-hash">
                <FaGit /> 3c9f5d8
              </div>
              <div className="commit-content">
                <div className="commit-title">
                  <FaDatabase /> Product Developer @ nucleusFUSION
                </div>
                <div className="commit-date">
                  <FaCalendar /> July 2024 - December 2024
                </div>
                <div className="commit-message">
                  <FaCodeBranch /> feat(platform): Built mentor-mentee connection platform
                  <ul>
                    <li>stack: React.js, Firebase</li>
                    <li>arch: Implemented real-time data synchronization</li>
                    <li>auth: Integrated Firebase Authentication</li>
                    <li>ui: Built responsive interface with modern design patterns</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="commit wow fadeInUp">
              <div className="commit-hash">
                <FaGit /> 2b1e4a7
              </div>
              <div className="commit-content">
                <div className="commit-title">
                  <FaCloud /> Technical Lead Freelance @ ProdigyPeak
                </div>
                <div className="commit-date">
                  <FaCalendar /> May 2024 - July 2024
                </div>
                <div className="commit-message">
                  <FaCodeBranch /> feat(website): Developed high-performance website
                  <ul>
                    <li>stack: React.js, EmailJS</li>
                    <li>perf: Implemented lazy loading and asset optimization</li>
                    <li>arch: Built reusable component architecture</li>
                    <li>state: Optimized state management patterns</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="command-line">
            <span className="prompt">$</span>
            <span className="directory">{currentDirectory}</span>
            <span className="cursor">|</span>
          </div>
        </div>
      </div>
    </section>
  );
}
